<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="type=='edit'?'Edit task file':'Add task file'"
        width="1000px"
        append-to-body
        top="5vh"
        class="dialog-body-border-bottom modal-body-padding-bottom-10"
        :before-close="handleClose">
        <div class="content-wrap pb20">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" v-loading="formLoading">
                <el-form-item label="Media：" prop="plat_id">
                    <el-radio-group v-model="formItem.plat_id" :disabled="taskType=='edit'&&type=='edit'" @change="changePlat">
                        <el-radio-button v-if="allowedPlatIds.includes('9')" label="9">Apple</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Template：" prop="template_id">
                    <el-select v-model="formItem.template_id" filterable placeholder="Please select template" loading-text="loading" @visible-change="templateSelectVisibleChange" :loading="templateLoading" style="width:296px;">
                        <el-option
                            v-for="item in templateList"
                            :key="item.template_id"
                            :label="item.template_name"
                            :value="item.template_id">
                        </el-option>
                    </el-select>
                    <!--<el-button type="primary" size="mini" class="ml10 mr10" :disabled="!formItem.template_id" @click="previewTemp">Preview</el-button>-->
                    <!--<el-button type="primary" size="mini" class="ml10 mr10" plain @click="toCreateTemp">Create Template</el-button>-->
                </el-form-item>
                <el-form-item label="Account & Product:：" class="label-required mr50" prop="account_app">
                    <el-radio-group v-model="formItem.selectAPPType" @change="changeAppType">
                        <el-radio label="1">Filter products
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px mb10" style="line-height: 1.5;">Based on the filtered products, statistics of the accounts that have the product in campaign and you have permission will be displayed according to the template. When new accounts are launched for the filtered products, there is no need to configure again; if you have permission for the account, it will be automatically included when the automated report is generated.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">Filter Accounts
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px">Based on the filtered accounts, all data will be statistically displayed in the template.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="3">Filter Clients
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px mb10" style="line-height: 1.5;">Based on the filtered clients, statistics of accounts belonging to and you have permission for this client will be displayed according to the template. When the filtered clients are bound to new accounts, there is no need to configure again; if you have permission for the account, it will be automatically included when the automated report is generated.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="4" v-if="type=='edit'||pageFuncNames.includes('daily_task_account_app')">Filter Accounts + Products
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px" style="line-height: 1.5;">Based on the filtered accounts and products, statistics for these products in these accounts will be displayed according to the template.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" class="mr50">
                    <div class="app-account-list app-list mt10" v-if="formItem.selectAPPType=='1'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">Selected Products：{{formItem.app.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="appSelect"
                                            class="full-w remote-select-tags-width"
                                            collapse-tags
                                            v-model="formItem.app"
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="Enter product name, ID, package name keyword to search"
                                            :remote-method="remoteApp"
                                            :loading="appLoading">
                                            <el-option
                                                v-for="(item,index) in appList"
                                                :key="item.subitem_id+index"
                                                :label="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')"
                                                :value="item.subitem_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedApp.length<=0" class="tac text-color-gray">No data available</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedApp" :key="item.subitem_id+index" >
                                                <p class="relative ellipsis pr60" :title="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')">
                                                    {{item.subproject_name}}（{{item.subproject_id}}）<span v-if="formItem.plat_id=='3'">（{{item.subproject_content}}）</span>
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('app',item.subitem_id)" title="Delete">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list company-list mt10" v-if="formItem.selectAPPType=='2'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">Selected Accounts：{{formItem.company.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="companySelect"
                                            class="full-w remote-select-tags-width"
                                            v-model="formItem.company"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="Enter account name, ID keyword to search"
                                            :remote-method="remoteCompany"
                                            :loading="companyLoading">
                                            <el-option
                                                v-for="(item,index) in companyList"
                                                :key="item.account_id+index"
                                                :label="item.account_name+'（'+(formItem.plat_id=='3'?item.user_name:item.account_id)+'）'"
                                                :value="item.account_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCompany.length<=0" class="tac text-color-gray">No data available</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCompany" :key="item.account_id+index" >
                                                <p class="relative ellipsis pr40" :title="item.account_name+'（'+formItem.plat_id=='3'?item.user_name:item.account_id+'）'">
                                                    {{item.account_name}}（{{formItem.plat_id=='3'?item.user_name:item.account_id}}）
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('company',item.account_id)" title="Delete">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list customer-list mt10" v-if="formItem.selectAPPType=='3'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">Selected Clients:：{{formItem.customer.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="customerSelect"
                                            class="full-w remote-select-tags-width"
                                            v-model="formItem.customer"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="Please Enter Client Keyword to Search"
                                            :remote-method="remoteCustomer"
                                            :loading="customerLoading">
                                            <el-option
                                                v-for="(item,index) in customerList"
                                                :key="item.company_name+index"
                                                :label="item.company_name"
                                                :value="item.company_name">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCustomer.length<=0" class="tac text-color-gray">No data available</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCustomer" :key="item.company_name+index" >
                                                <p class="relative ellipsis pr40" :title="item.company_name">
                                                    {{item.company_name}}
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('customer',item.company_name)" title="Delete">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list mt10" v-if="formItem.selectAPPType=='4'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">Selected Accounts：{{formItem.company.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="companySelect"
                                            class="full-w remote-select-tags-width"
                                            @change="changeCompany"
                                            v-model="formItem.company"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="Enter account name, ID keyword to search"
                                            :remote-method="remoteCompany"
                                            :loading="companyLoading">
                                            <el-option
                                                v-for="(item,index) in companyList"
                                                :key="item.account_id+index"
                                                :label="item.account_name+'（'+(formItem.plat_id=='3'?item.user_name:item.account_id)+'）'"
                                                :value="item.account_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCompany.length<=0" class="tac text-color-gray">No data available</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCompany" :key="item.account_id+index" >
                                                <p class="relative ellipsis pr40" :title="item.account_name+'（'+formItem.plat_id=='3'?item.user_name:item.account_id+'）'">
                                                    {{item.account_name}}（{{formItem.plat_id=='3'?item.user_name:item.account_id}}）
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('company',item.account_id)" title="Delete">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">Selected Products：{{formItem.app.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="appSelect"
                                            class="full-w remote-select-tags-width"
                                            @change="changeApp"
                                            collapse-tags
                                            v-model="formItem.app"
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="Enter product name, ID, package name keyword to search"
                                            :remote-method="remoteApp"
                                            :loading="appLoading">
                                            <el-option
                                                v-for="(item,index) in appList"
                                                :key="item.subitem_id+index"
                                                :label="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')"
                                                :value="item.subitem_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedApp.length<=0" class="tac text-color-gray">No data available</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedApp" :key="item.subitem_id+index" >
                                                <p class="relative ellipsis pr60" :title="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')">
                                                    {{item.subproject_name}}（{{item.subproject_id}}）<span v-if="formItem.plat_id=='3'">（{{item.subproject_content}}）</span>
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('app',item.subitem_id)" title="Delete">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <!-- 时区暂时隐藏掉 -->
                <el-form-item v-if="formItem.plat_id=='9'&&false" label="Time Zone：" prop="time_zone" class="label-required">
                    <el-radio-group v-model="formItem.time_zone">
                        <el-radio label="Asia/Shanghai">Time Zone - Shanghai</el-radio>
                        <el-radio label="UTC">Time Zone - UTC</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="File Name：" prop="daily_file_name">
                    <el-input v-model.trim="formItem.daily_file_name" placeholder="Please enter file name" style="width: 450px;"></el-input>
                    <el-checkbox v-model="formItem.file_date" true-label="1" false-label="0" class="ml10">+ Yesterday's date</el-checkbox>
                </el-form-item>
                <el-form-item class="label-required"  prop="time_slot">
                    <div class="inline-block" slot="label">
                        <el-tooltip class="item" effect="dark" content="Data for the relevant dates will be generated according to the set statistical period, without affecting cumulative indicators" placement="top-start">
                            <span><i class="el-icon-question pr4"></i>Statistics Period：</span>
                        </el-tooltip>
                    </div>
                    <el-radio-group v-model="formItem.statistical_period" @change="changeStatisticalPeriod">
                        <el-radio-button v-if="periodConfigNames.includes('last_7_days')" label="1">Last 7 days</el-radio-button>
                        <el-radio-button v-if="periodConfigNames.includes('last_30_days')" label="2">Last 30 days</el-radio-button>
                        <el-radio-button v-if="periodConfigNames.includes('all_days')" label="3">All campaign dates</el-radio-button>
                        <el-radio-button v-if="latestDaysConfig||is_super_admin" label="4" class="period-days">Custom recent days</el-radio-button>
                        <el-radio-button v-if="startDateConfig||is_super_admin" label="5" class="period-date">Custom start date</el-radio-button>
                    </el-radio-group>
                    <div class="ml10 inline-block period-customize-the-latest-days" v-if="formItem.statistical_period=='4'&&(latestDaysConfig||is_super_admin)">
                        Last <el-input-number v-model="formItem.time_slot" label="days" :disabled="!latestDaysConfig&&!is_super_admin" @change="changePeriodDays"  class="ml4 mr4"></el-input-number> days
                    </div>
                    <div class="ml10 inline-block period-customize-the-start-date" v-if="formItem.statistical_period=='5'&&(startDateConfig||is_super_admin)">
                        <el-date-picker
                            v-model="formItem.time_slot_date"
                            :picker-options="dateOptions"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :clearable="false"
                            :disabled="!startDateConfig&&!is_super_admin"
                            style="width: 160px;"
                            placeholder="Select a Date">
                        </el-date-picker>
                    </div>

                    <div slot="error" slot-scope="scope" class="font12px text-color-error absolute" :style="{left:periodErrorLeft}">{{scope.error}}</div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac pt8">
            <el-button type="default" @click="handleClose" class="action-btn mr20">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">{{type=='add'?'Add':'Save'}}</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/efficiencyToolEn/task.js';
    import {platMap} from '@/constant/index.js';

    import * as dayjs from 'dayjs'
    export default {
        name: "TaskFileModal",
        props:{
            allowedPlatList:Array,
            data:Object,
            type:String,
            taskType:String,
            pageFuncNames:Array,
        },
        data(){
            let _this = this;
            const validateAccountApp = (rule,value,callback)=>{
                if(!_this.formItem.selectAPPType){
                    callback(new Error('Please select accounts & products'));
                }if(_this.formItem.selectAPPType=='1'&&_this.formItem.app.length<=0){
                    callback(new Error('Please select products'));
                }else if(_this.formItem.selectAPPType=='2'&&_this.formItem.company.length<=0){
                    callback(new Error('Please select accounts'));
                }else if(_this.formItem.selectAPPType=='3'&&_this.formItem.customer.length<=0){
                    callback(new Error('Please select clients'));
                }else if(_this.formItem.selectAPPType=='4'){
                    if(_this.formItem.company.length<=0&&_this.formItem.app.length<=0){
                        callback(new Error('Please select accounts & products'));
                    }else if(_this.formItem.company.length<=0){
                        callback(new Error('Please select accounts'));
                    }else if(_this.formItem.app.length<=0){
                        callback(new Error('Please select products'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const validateTimeSlot = (rule,value,callback)=>{
                if(_this.formItem.statistical_period=='1'||_this.formItem.statistical_period=='2'||_this.formItem.statistical_period=='3'){
                    callback();
                }else if(_this.formItem.statistical_period=='4'){
                    if(!_this.formItem.time_slot){
                        callback(new Error('Custom recent days：please select'));
                    }else if(_this.formItem.time_slot<1){
                        callback(new Error('Custom recent days： can not be less than 1'));
                    }else if(+_this.formItem.time_slot%1!=0){
                        callback(new Error('Custom recent days：must be a positive integer'));
                    }else if(!_this.latestDaysConfig){
                        callback();
                    }else if(_this.formItem.time_slot>_this.latestDaysConfig){
                        callback(new Error('Custom recent days：must be less than '+_this.latestDaysConfig));
                    }else {
                        callback();
                    }
                }else if(_this.formItem.statistical_period=='5'){
                    if(!_this.formItem.time_slot_date){
                        callback(new Error('Custom start date：please select'));
                    }else if(_this.startDateConfig&&(new Date(_this.formItem.time_slot_date)).getTime()-1000*60*60*24 < new Date(_this.startDateConfig).getTime()){
                        callback(new Error('Custom start date：only dates '+_this.startDateConfig+' and later can be selected as the start date'));
                    }else {
                        callback();
                    }
                }else{
                    callback(new Error('Please set a statistics period:'));
                }
            };
            const validateFileName = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:?"<>|']/img;
                if(reg.test(value)){
                    callback(new Error('contains illegal characters：/\\*:?"<>|[]'));
                }else{
                    callback();
                }
            };
            return {
                dialogVisible:false,
                formLoading:false,
                formItem:{
                    plat_id:'',
                    plat_name:'',
                    template_id:'',
                    selectAPPType:'',
                    daily_file_name:'',
                    statistical_period:'',
                    time_slot:undefined,
                    app:[],
                    company:[],
                    customer:[],
                    time_slot_date:'',
                    file_date:'',
                    time_zone:'Asia/Shanghai',
                },
                rules:{
                    plat_id:[
                        { required: true, message: 'Please select a media', trigger: 'blur' },
                    ],
                    template_id:[
                        { required: true, message: 'Please select a template', trigger: 'blur' },
                    ],
                    account_app:[
                        { validator:validateAccountApp ,trigger:'blur'},
                    ],
                    daily_file_name:[
                        { required: true, message: 'Please enter file name', trigger: 'blur' },
                        { max: 100, message: 'File name cannot exceed 100 characters', trigger: 'blur' },
                        {pattern: /[^\[\]/\\*:?"<>|']+/g, message: 'contains illegal characters：/\\*:?"<>|[]',trigger: 'blur' },
                        { validator:validateFileName ,trigger:'blur'},
                    ],
                    time_slot:[
                        { validator:validateTimeSlot ,trigger:'blur'}
                    ],
                },
                templateLoading:false,
                templateList:[],
                appList:[],
                companyList:[],
                customerList:[],
                appLoading:false,
                companyLoading:false,
                customerLoading:false,
                dateOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        // if(_this.startDateConfig&&time.getTime() < new Date(_this.startDateConfig).getTime()){
                        //     return true;
                        // }else{
                        //     return time.getTime() > Date.now()-1000*60*60*24;
                        // }
                        return time.getTime() > Date.now()-1000*60*60*24;
                    },
                    cellClassName(time){
                        if(_this.startDateConfig&&time.getTime() < new Date(_this.startDateConfig).getTime()){
                            return '';
                        }else if(time.getTime() > Date.now()-1000*60*60*24){
                            return 'td-file-disabled-date-after';
                        }else{
                            return '';
                        }
                    },
                },
                allAppList:[],
                allCompanyList:[],
                allCustomerList:[],
            };
        },
        computed:{
            ...mapGetters(['daily_task_period_config','is_super_admin']),
            allowedPlatIds(){
                let platList = this.allowedPlatList||[];
                return platList.map(item=>item.id);
            },
            platName(){
                let platItem = platMap.find(item=>item.id==this.formItem.plat_id)||{};
                return platItem.displayName||'';
            },
            formCheckedApp(){
                let appIdList = this.formItem.app||[];
                return appIdList.map(id=>{
                    return this.allAppList.find(item=>item.subitem_id==id)||{};
                })
            },
            formCheckedCompany(){
                let companyIdList = this.formItem.company||[];
                return companyIdList.map(id=>{
                    return this.allCompanyList.find(item=>item.account_id==id)||{};
                })
            },
            formCheckedCustomer(){
                let customerIdList = this.formItem.customer||[];
                return customerIdList.map(id=>{
                    return this.allCustomerList.find(item=>item.company_name==id)||{};
                })
            },
            periodConfig(){
                return this.daily_task_period_config||[];
            },
            periodConfigNames(){
                return this.periodConfig.map(item=>item.name).filter(item=>!!item);
            },
            startDateConfig(){
                const { customize_the_start_date } = this.data;
                function subtractDay(date) {
                    return dayjs(new Date(date)).subtract(1, 'day').format('YYYY-MM-DD')
                }
                if (customize_the_start_date) {
                    // return customize_the_start_date
                    return subtractDay(customize_the_start_date);
                }
                let actionItem = this.periodConfig.find(item=>item.name=='customize_the_start_date');
                return actionItem? actionItem.config? subtractDay(actionItem.config) :'':'';
            },
            latestDaysConfig(){
                const { customize_the_latest_days } = this.data
                if (customize_the_latest_days) {
                    return customize_the_latest_days
                }
                let actionItem = this.periodConfig.find(item=>item.name=='customize_the_latest_days');
                return actionItem?+actionItem.config||'':'';
            },
            periodErrorLeft(){
                return 'auto';
                if(this.formItem.statistical_period=='4'){
                    let $periodDays = document.querySelector('.period-customize-the-latest-days');
                    if($periodDays){
                        return ($periodDays.offsetLeft+10)+'px';
                    }else {
                        return 'auto';
                    }
                }else if(this.formItem.statistical_period=='5'){
                    let $periodDays = document.querySelector('.period-customize-the-start-date');
                    if($periodDays){
                        return ($periodDays.offsetLeft+10)+'px';
                    }else {
                        return 'auto';
                    }
                }else{
                    return 'auto';
                }
            }
        },
        mounted(){
            let _this = this;
            $('body').on('mouseover', '.td-file-disabled-date', function (e) {
                // let $target = $(e.target);
                // let tipStr = '暂无权限，'+_this.startDateConfig+'及之前日期';
                // $target.attr('title', tipStr);
            }).on('mouseover', '.td-file-disabled-date-after', function (e) {
                let $target = $(e.target);
                let tipStr = 'Times after the current day cannot be selected';
                $target.attr('title', tipStr);
            });
        },
        methods:{
            showModal(){
                this.dialogVisible = true;

                this.$nextTick(()=>{
                    if(this.type=='edit'){
                        this.setData();
                    }else{
                        this.formItem.plat_id = '9';
                        this.formItem.file_date = '1';
                        this.setDefaultStatisticalPeriod();
                    }
                    this.getTemplateList();
                });
            },
            setData(){
                let data = this.data||{};

                this.formItem.plat_id = data.plat_id;
                this.formItem.plat_name = data.plat_name;
                this.formItem.template_id = data.template_id;
                this.formItem.selectAPPType = data.selectAPPType;
                this.formItem.daily_file_name = data.daily_file_name;

                this.formItem.file_date = data.file_date;
                this.formItem.time_slot = data.time_slot?data.time_slot:undefined;
                this.formItem.time_zone = data.time_zone;
                this.formItem.statistical_period = data.statistical_period;
                this.formItem.time_slot_date = data.time_slot_date;
                this.formItem.app = (data.app||[]).map(item=>item.subitem_id);
                this.formItem.company = (data.company||[]).map(item=>item.account_id);
                this.formItem.customer = (data.customer||[]).map(item=>item.company_name);
                this.allAppList = data.app||[];
                this.allCompanyList = data.company||[];
                this.allCustomerList = data.customer||[];

                this.appList = [...this.allAppList];
                this.companyList = [...this.allCompanyList];
                this.customerList = [...this.allCustomerList];
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem = {
                    plat_id:'',
                    template_id:'',
                    selectAPPType:'',
                    daily_file_name:'',
                    statistical_period:'',
                    time_slot:undefined,
                    time_zone:'Asia/Shanghai',
                    app:[],
                    company:[],
                    customer:[],
                    time_slot_date:'',
                    file_date:'',
                };
                this.appLoading = false;
                this.appList = [];
                this.companyLoading = false;
                this.companyList = [];
                this.customerLoading = false;
                this.customerList = [];
                this.$refs.form.clearValidate();
                this.allAppList = [];
                this.allCompanyList = [];
                this.allCustomerList = [];
                this.setDefaultStatisticalPeriod();
            },
            setDefaultStatisticalPeriod(){
                let firstKey = this.periodConfigNames[0];
                if(firstKey){
                    let dataMap = {
                        last_7_days:'1',
                        last_30_days:'2',
                        all_days:'3',
                        customize_the_latest_days:'4',
                        customize_the_start_date:'5',
                    };
                    this.formItem.statistical_period = dataMap[firstKey]||'';
                }
            },
            getTemplateList(){
                console.log('getTemplateList');
                if(!this.formItem.plat_id) return this.templateList = [];
                this.templateList = [];
                this.templateLoading = true;
                API.getPlatTemplateList({
                    plat_id:this.formItem.plat_id,
                }).then(res=>{
                    this.templateList = res.data||[];
                    this.templateLoading = false;
                },err=>{
                    console.log('getTemplateList err',err);
                    this.templateList = [];
                    this.templateLoading = false;
                });
            },
            previewTemp(){
                let platId = this.formItem.plat_id;
                let templateId = this.formItem.template_id;
                let templateItem = this.templateList.find(item=>item.template_id==templateId)||{};
                console.log('previewTemp',platId,templateId);

                let $router= this.$router.resolve({
                    name:'daily_task_en',
                    query:{
                        platId:platId,
                        templateId:templateId,
                        templateName:templateItem.template_name,
                        pageType:'view_template',
                    },
                });
                window.open($router.href, '_blank');
            },
            toCreateTemp(){
                let platId = this.formItem.plat_id;
                console.log('toCreateTemp',platId);

                if(platId==8){
                    if(!this.pageFuncNames.includes('daily_task_create_template')){
                        return this.$message.error('No permission');
                    }
                }else{
                    if(!this.pageFuncNames.includes('daily_task_create_template_new')){
                        return this.$message.error('No permission');
                    }
                }

                let $router= this.$router.resolve({
                    name:'daily_task_en',
                    query:{
                        platId:platId,
                        pageType:'create_template',
                    },
                });
                window.open($router.href, '_blank');
            },
            changePlat(val){
                console.log('changePlat',val);
                // this.getTemplateList();
                this.formItem.template_id = '';

                this.selectAPPType = '';
                this.appLoading = false;
                this.appList = [];
                this.formItem.app = [];
                this.companyLoading = false;
                this.companyList = [];
                this.formItem.company = [];
                this.customerLoading = false;
                this.customerList = [];
                this.formItem.customer = [];

                this.formItem.daily_file_name = '';
                this.formItem.file_date = '1';
                this.formItem.statistical_period = '1';
                this.formItem.time_slot_date = '';
                this.formItem.time_slot = undefined;
            },
            templateSelectVisibleChange(val){
                if(val){
                    this.getTemplateList();
                }
            },
            changeStatisticalPeriod(val){
                /* 3: 全部投放日期； 4：自定义天数； 5：自定义开始日期*/
                if(val=='4'){
                    this.formItem.time_slot = undefined;
                    this.$refs.form.clearValidate('time_slot');
                }else if(val=='5'){
                    this.formItem.time_slot = undefined;
                    this.formItem.time_slot_date = null;
                    this.$refs.form.clearValidate('time_slot');
                }else{
                    this.$refs.form.validateField('time_slot');
                }
            },
            changeAppType(){
                this.appLoading = false;
                this.appList = [];
                this.formItem.app = [];
                this.companyLoading = false;
                this.companyList = [];
                this.formItem.company = [];
                this.customerLoading = false;
                this.customerList = [];
                this.formItem.customer = [];
            },
            remoteCompany(query){
                if(!query){
                    return this.companyList = [];
                }
                this.companyLoading = true;
                let selectAPPType = this.formItem.selectAPPType;
                API.getAppCompanyList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                    subitem_ids:selectAPPType=='4'?this.formItem.app:[],
                }).then(res => {
                    let resData = res.data || [];
                    this.companyLoading =  false;
                    this.companyList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCompanyList.map(item=>item.account_id).includes(item.account_id)){
                            this.allCompanyList.push(item);
                        }
                    })
                },err=>{
                    this.companyLoading = false;
                    this.$message.error(err.info||'Request Error');
                    this.companyList = [];
                });
            },
            remoteCustomer(query){
                if(!query){
                    return this.customerList = [];
                }
                this.customerLoading = true;
                API.getCustomerList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                }).then(res => {
                    let resData = res.data || [];
                    this.customerLoading =  false;
                    this.customerList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCustomerList.map(item=>item.company_name).includes(item.company_name)){
                            this.allCustomerList.push(item);
                        }
                    })
                },err=>{
                    this.customerLoading = false;
                    this.$message.error(err.info||'Request Error');
                    this.customerList = [];
                });
            },
            remoteApp(query){
                if(!query){
                    return this.companyList = [];
                }
                this.appLoading = true;
                let selectAPPType = this.formItem.selectAPPType;
                API.getCompanyAppList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                    account_ids:selectAPPType=='4'?this.formItem.company:[],
                }).then(res => {
                    let resData = res.data || [];
                    this.appLoading =  false;
                    this.appList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allAppList.map(item=>item.subitem_id).includes(item.subitem_id)){
                            this.allAppList.push(item);
                        }
                    })
                },err=>{
                    this.appLoading = false;
                    this.$message.error(err.info||'Request Error');
                    this.appList = [];
                });
            },
            changeCompany(){
                this.appList = [];
                this.getAppList();
            },
            changeApp(){
                this.companyList = [];
                this.getCompanyList();
            },
            getAppList(){
                if(this.formItem.company.length<=0){
                    return this.appList = [];
                }
                this.appLoading = true;
                API.getCompanyAppList({
                    plat_id:this.formItem.plat_id,
                    search:'',
                    account_ids:this.formItem.company,
                }).then(res => {
                    let resData = res.data || [];
                    this.appLoading =  false;
                    this.appList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allAppList.map(item=>item.subitem_id).includes(item.subitem_id)){
                            this.allAppList.push(item);
                        }
                    })
                },err=>{
                    this.appLoading = true;
                    this.$message.error(err.info||'Request Error');
                    this.appList = [];
                });
            },
            getCompanyList(){
                if(this.formItem.app.length<=0){
                    return this.companyList = [];
                }
                this.companyLoading = true;
                API.getAppCompanyList({
                    plat_id:this.formItem.plat_id,
                    search:'',
                    subitem_ids:this.formItem.app,
                }).then(res => {
                    let resData = res.data || [];
                    this.companyLoading =  false;
                    this.companyList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCompanyList.map(item=>item.account_id).includes(item.account_id)){
                            this.allCompanyList.push(item);
                        }
                    })
                },err=>{
                    this.companyLoading = true;
                    this.$message.error(err.info||'Request Error');
                    this.companyList = [];
                });
            },
            removeChecked(type,id){
                console.log('removeChecked',type,id);
                let actionList = this.formItem[type];
                let index = actionList.findIndex(item=>item==id);
                if(index!=-1){
                    actionList.splice(index,1);
                }
                if(type=='app'&&this.formItem.selectAPPType=='1'){
                    /* 产品维度选账户，改变产品后，清空账户列表，重新更新账户列表 */
                    this.formItem.company = [];
                    this.getCompanyList();
                }
                if(type=='company'&&this.formItem.selectAPPType=='2'){
                    /* 账户维度选产品，改变账户后，清空产品列表，重新更新产品列表 */
                    this.formItem.app = [];
                    this.getAppList();
                }
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = {...this.formItem};
                        data.task_detail_id = this.data.task_detail_id;
                        data.plat_name = this.platName;
                        data.template_name = (this.templateList.find(item=>item.template_id==this.formItem.template_id)||{}).template_name||'';
                        data.app = data.app.map(item=>this.allAppList.find(inner=>inner.subitem_id==item)||{});
                        data.company = data.company.map(item=>this.allCompanyList.find(inner=>inner.account_id==item)||{});
                        data.customer = data.customer.map(item=>this.allCustomerList.find(inner=>inner.company_name==item)||{});
                        this.$emit('submit',this.type,{...data});
                        this.hideModal();
                    } else {
                        console.log('error submit!!');
                        this.$message.error('Form data contains errors. Please check and resubmit');
                        return false;
                    }
                });
            },
            changePeriodDays(){
                this.$refs.form.validateField('time_slot');
            },
        }
    }
</script>

<style lang="scss" scoped>

    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }

    .app-account-list{
        .title-group{
            font-size: 12px;
            border-bottom: solid 1px #ccc;
            text-indent: 10px;
        }
        .list-wrap{
            border: solid 1px #ccc;

        }
        .checked-list{
            height: 200px;
            overflow-y: auto;
            padding: 10px;
            font-size: 12px;

            li{
                padding-left: 10px;
                p{
                    line-height: 24px;
                }
            }
            .remove-btn{
                right: 10px;
            }
        }

        .hide-tag ::v-deep  .el-select__tags .el-tag{
            display: none;
        }
    }

    .text-color-error{
        color: #F56C6C!important;
    }



</style>
